<template>
  <div style="height: 100vh; background-color: #f7fafe">
    <div style="width: 960px; margin: 0 auto; background-color: #f7fafe">
      <iframe
        id="detail-frame"
        :src="src"
        height="640px"
        style="height: 80vh; width: 960px; border: none"
      />
      
      <div style=" border-bottom: 1px solid #aaaa; margin-bottom: 20px" />
      
      <div style="display: flex; justify-content: flex-end; gap: 20px">
        <Flex column>
          <v-btn color="primary" depressed outlined @click="handleUpdate">
            プレビューの更新
          </v-btn>
          <p style="line-height: 1.1rem; font-size: 12px; color: gray; text-align: center; margin-top: 2px">
            データが表示されない場合<br>こちらで更新が出来ます
          </p>
        </Flex>
        <v-btn color="primary" depressed outlined @click="back">戻る</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import ComponentMixin from '../../../ComponentMixin';
  import ApiMixin from '../../../../ApiMixin'
  import Flex from '../../../atoms/Flex.vue'

  export default {
    components: { Flex },
    mixins: [ComponentMixin, ApiMixin],
    type: "page",
    name: "ClientJobDetailPage",
    data() {
      return {
        jobDetail: undefined
      }
    },
    computed: {
      draft () {
        return this.$route.meta.draft || false
      },
      src() {
        return `${process.env.VUE_APP_NISHIKA_URL}/jobs/preview`
      },
    },
    async mounted () {
      await this.setJobDetail()
  
      setTimeout(() => { // 即postMessageしても受け取れてないので、Delayをかける
        this.postMessage()
      }, 2000)
    },
    methods: {
      async setJobDetail() {
        this.jobDetail = await this.loadJob(this.$route.params.id, this.draft)
      },
      postMessage() {
        const iframe = document.getElementById('detail-frame');
        const iframeWindow = iframe.contentWindow;
        iframeWindow.postMessage(JSON.stringify(this.jobDetail), process.env.VUE_APP_NISHIKA_URL);
      },
  
      async handleUpdate() {
        await this.setJobDetail()
        this.postMessage()
      }
    }
  }
</script>

<style scoped lang="sass">
</style>
